export const apiConstants = {
  url: "/api/frontend",
  sendRegistration: "/api/send-registration",
  saveRegistration: "/api/save-registration",
  registration: "/api/registration",
  myFamily: "/api/my-family",
  myFamilyChildren: "/api/my-family/children",
  myFamilyParent: "/api/my-family/parent"
};
